import api from "../api.js"; 

export const SECTORS_21 = [
  'शहरी योजना तथा भौतिक पूर्वाधार',
  'सुरक्षा',
  'खानेपानी',
  'फोहोर तथा प्रदूषण व्यवस्थापन',
  'वन, वातावरण र पर्यटन',
  'शिक्षा, अनुसन्धान र ज्ञान',
  'शिल्प, सीप तथा उद्यमशीलता',
  'स्वास्थ्य तथा जनस्वास्थ्य',
  'स्वस्थ जीवनशैली र उपभोक्ता हित',
  'खेलकुद तथा खेल प्रशिक्षण',
  'सूचना प्रविधि तथा स्मार्ट सिटी',
  'मिडिया तथा सञ्चार',
  'व्यापार, उद्योग र आर्थिक विकास',
  'कृषि तथा सहकारी',
  'विपद् व्यवस्थापन',
  'कला, संस्कृति र पहिचान',
  'सुशासन, आर्थिक नीति र वित्तीय व्यवस्थापन',
  'सामाजिक सुरक्षा र समावेशी विकास',
  'महिला, बालबालिका र युवा विकास',
  'अन्तर्राष्ट्रिय सम्बन्ध',
  'नगर शासन र सार्वजनिक सेवा',
];

/**
 * Fetch the published news list. Optionally filter by sector and/or search term —
 * matches the query params your backend's getNews controller already supports.
 */
export const fetchNewsList = async ({ sector, search } = {}) => {
  const params = {};
  if (sector && sector !== 'All') params.sector = sector;
  if (search) params.search = search;

  const { data } = await api.get(`/news`, { params });
  return data;
};

/**
 * Fetch a single article by its MongoDB _id.
 * Note: hitting this endpoint also increments the view count on the backend.
 */
export const fetchNewsById = async (id) => {
  const { data } = await api.get(`/news/${id}`);
  return data;
};

/**
 * Editor-only: fetch all pending (unreviewed) articles.
 * Requires protect + authorizeRoles('admin','editor') on the backend.
 */
export const fetchPendingNews = async () => {
  const { data } = await api.get(`/news/pending`);
  return data;
};

/**
 * Reporter/Editor/Admin: submit a new article.
 */
export const createNews = async (payload) => {
  const { data } = await api.post(`/news`, payload);
  return data;
};

/**
 * Editor/Admin: edit article fields (title, content, sector, imageUrl, etc).
 */
export const updateNews = async (id, payload) => {
  const { data } = await api.put(`/news/${id}`, payload);
  return data;
};

/**
 * Editor/Admin: change article status — 'pending' | 'published' | 'rejected'.
 */
export const updateNewsStatus = async (id, status) => {
  const { data } = await api.put(`/news/${id}/status`, { status });
  return data;
};

/**
 * Admin only: delete an article permanently.
 */
export const deleteNews = async (id) => {
  const { data } = await api.delete(`/news/${id}`);
  return data;
};

/**
 * Editor/Admin dashboard: paginated, with status/search/sector filters and status counts.
 * Returns { data, counts: {pending, published, rejected}, pagination: {total, page, limit, totalPages} }
 */
export const fetchNewsForDashboard = async ({ status, sector, search, page = 1, limit = 20 } = {}) => {
  const params = { page, limit };
  if (status && status !== 'All') params.status = status;
  if (sector && sector !== 'All') params.sector = sector;
  if (search) params.search = search;

  const { data } = await api.get(`/news`, { params });
  return data; // { data, counts, pagination }
};

/**
 * Reporter: fetch own articles with status counts.
 * Returns { data: [...], counts: { total, pending, published, rejected } }
 */
export const fetchMyNews = async () => {
  const { data } = await api.get(`/news/my`);
  return data;
};

/**
 * Reporter: delete own article.
 */
export const deleteMyNews = async (id) => {
  const { data } = await api.delete(`/news/my/${id}`);
  return data;
};